import { useCallback, useEffect, useMemo, useState } from "react";
import { uniqBy } from "lodash";

import { useDelay, usePagination, useRequest } from "hooks";

import toGlobalId from "scenes/Hubly/components/Workspace/api/helper";

export function useContactSelector(sourceClientId) {
  const queryFactory = useCallback(() => {
    const query = `
      query findSimilarClients($searchText: String, $clientId: ID, $pageSize: Int, $after: String) {
        searchClients(searchText: $searchText, clientId: $clientId, showDeletedInCrm: false, first: $pageSize, after: $after) {
          edges {
            node {
              id
              name
            }
          }
          pageInfo {
            hasNextPage
            endCursor
          }
        }
      }`;

    const resolver = ({ data: { searchClients } }) => {
      return {
        data: searchClients.edges.map(({ node }) => {
          return node;
        }),
        pageInfo: searchClients.pageInfo,
      };
    };

    return { query, resolver };
  }, []);

  const [targetClient, setTargetClient] = useState();
  const [searchText, setSearchText] = useState("");
  const delayCallback = useDelay(250);

  const { req } = useRequest(queryFactory);
  const page = usePagination(req, {
    variables: useMemo(() => {
      return {
        searchText: searchText,
        clientId: toGlobalId("Client", sourceClientId),
      };
    }, [searchText, sourceClientId]),
    options: { pageSizes: [5, 10, 50] },
  });

  useEffect(() => {
    if (
      page.fetchCount === 1 &&
      !page.isEmpty &&
      page.data &&
      !page.loading &&
      !targetClient
    ) {
      setTargetClient(page.data[0]);
    }
  }, [page, targetClient, setTargetClient]);

  return {
    page: {
      ...page,
      data:
        targetClient && Array.isArray(page.data)
          ? uniqBy([targetClient].concat(page.data), "id")
          : page.data,
    },
    setSelected: setTargetClient,
    selected: targetClient,
    setSearchText: (text) => {
      delayCallback(() => {
        setSearchText(text);
      });
    },
  };
}

export default useContactSelector;
